import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { truncate } from "src/helpers/helperFunctions";

interface IProps {
  data: {
    label: string | { label: string; onClick?: () => void }[];
    onClick?: () => void;
    highlight?: boolean;
    arrow?: boolean;
  }[];
}

const CustomBreadCrub = ({ data }: IProps) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <div className="w-full flex items-center gap-2">
      {data.map((item, index) => (
        <div
          key={index}
          className={`flex items-center gap-2 text-[#2D2D2D] ${
            item.highlight || index === data.length - 1 ? "" : "opacity-65"
          }`}
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          {typeof item.label === "string" ? (
            <button
              className={`font-Poppins-Regular font-size-15px text-[#2D2D2D] ${
                item.onClick && index !== data.length - 1 ? "cursor-pointer hover:underline" : ""
              }`}
              onClick={() => {
                if (item.onClick && index !== data.length - 1) {
                  item.onClick();
                }
              }}
            >
              {hoveredIndex !== index ? truncate(item.label, 20) : item.label}
            </button>
          ) : (
            <>
              {hoveredIndex !== index
                ? truncate(item.label?.join(", "), 20)
                : item.label?.map((bread, ind) => (
                    <button
                      className={`font-Poppins-Regular font-size-15px text-[#2D2D2D] ${
                        bread.onClick && index !== data.length - 1 ? "cursor-pointer hover:underline" : ""
                      }`}
                      onClick={() => {
                        if (bread.onClick && index !== data.length - 1) {
                          bread.onClick();
                        }
                      }}
                    >
                      bread.label
                    </button>
                  ))}
            </>
          )}
          <FontAwesomeIcon icon={faChevronRight} className="text-[clamp(10px,0.7vw,15px)]" />
        </div>
      ))}
    </div>
  );
};

export default CustomBreadCrub;
